// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__3zMWL","owner":"style_owner__6gY88","card":"style_card__1gsU9","messageText":"style_messageText__2JQL2"};